import React, { useState, useEffect, useRef } from "react";
import { GALLERY_LINKS, GALLERY_QR } from "../utils/config";
import weddingRing from "../assets/photos/wedding-ring.png";

// ── PROPOSAL PHOTOS — imported from your assets folder ────
// [EDIT] To add/change proposal photos:
//   1. Put .jpeg files in src/assets/Proposal_Photos/
//   2. Import them below
//   3. Add them to the PROPOSAL_PHOTOS array
import prop1 from "../assets/Proposal_Photos/proposal.jpeg";
import prop2 from "../assets/Proposal_Photos/proposal2.jpeg";
import prop3 from "../assets/Proposal_Photos/proposal3.jpeg";
import prop4 from "../assets/Proposal_Photos/proposal9.jpeg";
import prop5 from "../assets/Proposal_Photos/proposal4.jpeg";
import prop6 from "../assets/Proposal_Photos/proposal5.jpeg";
import prop7 from "../assets/Proposal_Photos/proposal6.jpeg";
import prop10 from "../assets/Proposal_Photos/proposal10.jpeg";
import prop11 from "../assets/Proposal_Photos/proposal11.jpeg";
import prop12 from "../assets/Proposal_Photos/proposal12.jpeg";
import prop13 from "../assets/Proposal_Photos/proposal13.jpeg";
import prop14 from "../assets/Proposal_Photos/proposal14.jpeg";
import prop15 from "../assets/Proposal_Photos/proposal15.jpeg";
import prop16 from "../assets/Proposal_Photos/proposal16.jpeg";
import prop17 from "../assets/Proposal_Photos/proposal17.jpeg";
import prop18 from "../assets/Proposal_Photos/proposal18.jpeg";
import prop19 from "../assets/Proposal_Photos/proposal19.jpeg";

const PROPOSAL_PHOTOS = [
  { photo: prop1, cap: "He got down on one knee…" },
  { photo: prop2, cap: "Getting ready for the moment" },
  { photo: prop3, cap: "She said yes before he finished" },
  { photo: prop4, cap: "The ring that sealed forever" },
  { photo: prop5, cap: "Big question" },
  { photo: prop6, cap: "A moment to remember" },
  { photo: prop7, cap: "A kiss to seal the deal" },
  { photo: prop10, cap: "A promise for a lifetime" },
  { photo: prop11, cap: "The beginning of forever" },
  { photo: prop12, cap: "The start of our journey" },
  { photo: prop13, cap: "The sparkle of love" },
  { photo: prop14, cap: "A day to remember" },
  { photo: prop15, cap: "The ring that sealed forever" },
  { photo: prop16, cap: "A moment of pure happiness" },
  { photo: prop17, cap: "The ring that sealed forever" },
  { photo: prop18, cap: "A day filled with love" },
  { photo: prop19, cap: "The ring that sealed forever" },
];

// ── EVENT CARDS ───────────────────────────────────────────
// Front shows the event · Flip reveals QR code + View Gallery button.
// Links & QR images come from config.js (GALLERY_LINKS + GALLERY_QR)
const EVENTS = [
  {
    id: "lobola",
    icon: "🐂",
    name: "Patlo, Magadi & Pholoso",
    date: "11 Sep",
    sub: "Serowe Makolojwane",
    bg: "linear-gradient(145deg,#9ECFBE,#5A8262)",
    link: GALLERY_LINKS.lobola,
    qr: GALLERY_QR.lobola,
  },
  {
    id: "rustic",
    icon: (
      <img
        src={weddingRing}
        alt="Wedding ring"
        style={{ width: "40px", height: "40px", objectFit: "contain" }}
      />
    ),
    name: "Serowe Celebration",
    date: "12 Sep",
    sub: "Serowe",
    bg: "linear-gradient(145deg,#C5A05A,#8B6914)",
    link: GALLERY_LINKS.rustic,
    qr: GALLERY_QR.rustic,
  },
  {
    id: "reception",
    icon: "🥂",
    name: "Evening Wedding",
    date: "19 Sep",
    sub: "Mokolodi Base Bush Lounge",
    bg: "linear-gradient(145deg,#243C28,#4A7250)",
    link: GALLERY_LINKS.reception,
    qr: GALLERY_QR.reception,
  },
  {
    id: "culture",
    icon: "🤝",
    name: "Kgoroso",
    date: "20 Sep",
    sub: "Gaborone North",
    bg: "linear-gradient(145deg,#7ECFB8,#3E6642)",
    link: GALLERY_LINKS.culture,
    qr: GALLERY_QR.culture,
  },
];

// ── PROPOSAL SLIDESHOW MODAL ──────────────────────────────
function ProposalModal({ onClose }) {
  const [cur, setCur] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCur((c) => (c + 1) % PROPOSAL_PHOTOS.length);
    }, 4000);
    return () => clearInterval(timerRef.current);
  }, []);

  const goTo = (n) => {
    clearInterval(timerRef.current);
    setCur((n + PROPOSAL_PHOTOS.length) % PROPOSAL_PHOTOS.length);
  };

  useEffect(() => {
    const fn = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [onClose]);

  return (
    <div
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 900,
        background: "rgba(0,0,0,.88)",
        backdropFilter: "blur(20px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#0d1a0e",
          border: ".5px solid rgba(107,155,111,.25)",
          borderRadius: "14px",
          overflow: "hidden",
          width: "100%",
          maxWidth: "820px",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 32px 80px rgba(0,0,0,.7)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 22px",
            borderBottom: ".5px solid rgba(107,155,111,.2)",
            flexShrink: 0,
          }}
        >
          <div>
            <div
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "22px",
                color: "#fff",
                fontWeight: 300,
              }}
            >
              💍 The Proposal
            </div>
            <div
              style={{
                fontSize: "9px",
                letterSpacing: ".15em",
                textTransform: "uppercase",
                color: "var(--sage-l)",
                marginTop: "3px",
              }}
            >
              South Africa · July 2025
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              border: ".5px solid rgba(255,255,255,.2)",
              background: "transparent",
              color: "rgba(255,255,255,.7)",
              fontSize: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✕
          </button>
        </div>

        {/* Slideshow */}
        <div
          style={{
            position: "relative",
            flex: 1,
            minHeight: "340px",
            overflow: "hidden",
          }}
        >
          {PROPOSAL_PHOTOS.map((s, i) => (
            <div
              key={i}
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `url(${s.photo})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundColor: "#000",
                opacity: i === cur ? 1 : 0,
                transition: "opacity .9s ease",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: "16px 22px",
                  background: "linear-gradient(transparent,rgba(0,0,0,.72))",
                  fontFamily: "var(--font-serif)",
                  fontStyle: "italic",
                  fontSize: "15px",
                  color: "rgba(255,255,255,.9)",
                }}
              >
                {s.cap}
              </div>
            </div>
          ))}

          {["‹", "›"].map((arrow, dir) => (
            <button
              key={dir}
              onClick={() => goTo(cur + (dir === 0 ? -1 : 1))}
              style={{
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                [dir === 0 ? "left" : "right"]: "12px",
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                border: ".5px solid rgba(255,255,255,.2)",
                background: "rgba(0,0,0,.35)",
                backdropFilter: "blur(10px)",
                color: "#fff",
                fontSize: "20px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2,
              }}
            >
              {arrow}
            </button>
          ))}

          <div
            style={{
              position: "absolute",
              bottom: "12px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "6px",
              zIndex: 2,
            }}
          >
            {PROPOSAL_PHOTOS.map((_, i) => (
              <div
                key={i}
                onClick={() => goTo(i)}
                style={{
                  height: "5px",
                  borderRadius: "3px",
                  cursor: "pointer",
                  width: i === cur ? "18px" : "5px",
                  background:
                    i === cur
                      ? "rgba(168,197,160,.95)"
                      : "rgba(255,255,255,.35)",
                  transition: "all .35s cubic-bezier(.22,1,.36,1)",
                }}
              />
            ))}
          </div>
        </div>

        {/* Thumbnails */}
        <div
          style={{
            display: "flex",
            gap: "6px",
            padding: "10px 14px",
            background: "#0a1208",
            borderTop: ".5px solid rgba(107,155,111,.15)",
            overflowX: "auto",
            flexShrink: 0,
          }}
        >
          {PROPOSAL_PHOTOS.map((s, i) => (
            <div
              key={i}
              onClick={() => goTo(i)}
              style={{
                width: "54px",
                height: "54px",
                borderRadius: "6px",
                flexShrink: 0,
                cursor: "pointer",
                backgroundImage: `url(${s.photo})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                border:
                  i === cur ? "2px solid var(--sage)" : "2px solid transparent",
                transition: "border-color .2s",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

// ── FLIP CARD ─────────────────────────────────────────────
function FlipCard({ ev }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      onClick={() => setFlipped((f) => !f)}
      style={{
        perspective: "1200px",
        aspectRatio: "4/3",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          transformStyle: "preserve-3d",
          WebkitTransformStyle: "preserve-3d",
          transition: "transform .7s cubic-bezier(.22,1,.36,1)",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* ── FRONT ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
            borderRadius: "10px",
            overflow: "hidden",
            background: ev.bg,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(0,0,0,.4)",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to bottom,rgba(0,0,0,.05) 0%,rgba(0,0,0,.55) 100%)",
            }}
          />
          <div
            style={{
              position: "relative",
              zIndex: 1,
              textAlign: "center",
              padding: "16px",
            }}
          >
            <div
              style={{
                fontSize: "28px",
                marginBottom: "8px",
                filter: "drop-shadow(0 2px 6px rgba(0,0,0,.4))",
              }}
            >
              {ev.icon}
            </div>
            <div
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "18px",
                color: "#fff",
                fontWeight: 300,
                marginBottom: "3px",
                lineHeight: 1.2,
              }}
            >
              {ev.name}
            </div>
            <div
              style={{
                fontSize: "9px",
                letterSpacing: ".14em",
                textTransform: "uppercase",
                color: "var(--gold-l, #E5D5A5)",
                marginBottom: "3px",
              }}
            >
              {ev.date}
            </div>
            <div
              style={{
                fontSize: "9px",
                letterSpacing: ".08em",
                color: "rgba(255,255,255,.55)",
              }}
            >
              {ev.sub}
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
              zIndex: 1,
              background: "rgba(255,255,255,.12)",
              backdropFilter: "blur(8px)",
              border: ".5px solid rgba(255,255,255,.2)",
              borderRadius: "14px",
              padding: "3px 10px",
              fontSize: "8px",
              letterSpacing: ".1em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,.7)",
            }}
          >
            Tap to flip ↻
          </div>
        </div>

        {/* ── BACK ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            borderRadius: "10px",
            overflow: "hidden",
            background: "#0d1a0e",
            border: ".5px solid rgba(107,155,111,.3)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            gap: "10px",
          }}
        >
          {/* QR code */}
          {ev.qr ? (
            <img
              src={ev.qr}
              alt={`${ev.name} QR`}
              style={{
                width: "150px",
                height: "150px",
                objectFit: "contain",
                background: "#fff",
                padding: "8px",
                borderRadius: "10px",
              }}
            />
          ) : (
            <div
              style={{
                width: "88px",
                height: "88px",
                borderRadius: "8px",
                border: "1.5px dashed rgba(107,155,111,.4)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "9px",
                color: "var(--sage-l)",
                textAlign: "center",
                gap: "3px",
              }}
            >
              <span style={{ fontSize: "18px" }}>📷</span>
              QR here
            </div>
          )}

          <div
            style={{
              fontSize: "9px",
              letterSpacing: ".08em",
              color: "var(--sage-l)",
              textAlign: "center",
              lineHeight: 1.5,
            }}
          >
            Scan to view &amp; add photos
          </div>

          {ev.link && (
            <a
              href={ev.link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "7px 16px",
                background: "rgba(107,155,111,.25)",
                border: ".5px solid rgba(107,155,111,.5)",
                borderRadius: "16px",
                fontSize: "9px",
                letterSpacing: ".1em",
                textTransform: "uppercase",
                color: "var(--sage-l)",
                textDecoration: "none",
              }}
            >
              View Gallery ↗
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

// ── MAIN GALLERY ──────────────────────────────────────────
export default function Gallery() {
  const [showProposal, setShowProposal] = useState(false);

  return (
    <>
      <section
        id="gallery"
        style={{ background: "var(--deep)", padding: "96px 36px" }}
      >
        <div style={{ maxWidth: "960px", margin: "0 auto" }}>
          <div
            className="reveal"
            style={{ textAlign: "center", marginBottom: "44px" }}
          >
            <div
              className="section-tag"
              style={{
                color: "var(--gold)",
                justifyContent: "center",
                display: "flex",
              }}
            >
              Gallery
            </div>
            <h2 className="section-title light">
              Our <em>moments</em>
            </h2>
            <p
              style={{
                fontSize: "11px",
                color: "var(--sage-l)",
                marginTop: "10px",
                letterSpacing: ".06em",
              }}
            >
              Tap the Proposal for a slideshow · Flip any event card to scan the
              QR and share moment with us &amp; view its photo album
            </p>
          </div>

          {/* PROPOSAL — big feature card with slideshow */}
          <div
            className="reveal"
            onClick={() => setShowProposal(true)}
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              cursor: "pointer",
              position: "relative",
              height: "260px",
              marginBottom: "16px",
              backgroundImage: `url(${PROPOSAL_PHOTOS[0].photo})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,.5)",
              transition: "transform .3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.01)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "none";
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to bottom,rgba(0,0,0,.1) 0%,rgba(0,0,0,.7) 100%)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "20px",
                left: "24px",
                zIndex: 1,
              }}
            >
              <div style={{ fontSize: "26px", marginBottom: "6px" }}>💍</div>
              <div
                style={{
                  fontFamily: "var(--font-serif)",
                  fontSize: "28px",
                  color: "#fff",
                  fontWeight: 300,
                }}
              >
                The Proposal
              </div>
              <div
                style={{
                  fontSize: "9px",
                  letterSpacing: ".16em",
                  textTransform: "uppercase",
                  color: "rgba(255,255,255,.7)",
                  marginTop: "4px",
                }}
              >
                South Africa · July 2025 · Tap to view slideshow
              </div>
            </div>
          </div>

          {/* EVENT FLIP CARDS */}
          <div
            className="reveal"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px",
            }}
          >
            {EVENTS.map((ev) => (
              <FlipCard key={ev.id} ev={ev} />
            ))}
          </div>

          <div
            className="reveal"
            style={{
              textAlign: "center",
              marginTop: "22px",
              fontSize: "10px",
              color: "var(--muted)",
              letterSpacing: ".07em",
            }}
          >
            Guest photos live on Google Photos · Scan the QR or tap View Gallery
            · No account needed to view or upload
          </div>
        </div>
      </section>

      {showProposal && <ProposalModal onClose={() => setShowProposal(false)} />}
    </>
  );
}
